<template>
  
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="row nav_Breadcrumb">
          <div class="col">
            <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('Settings.breadcrumb_1')}}</router-link></li>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
                <li class="active mx-3 almarai-bold" aria-current="page">
                  {{$t('Settings.breadcrumb_2')}}
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="row py-5">
          <div class="col-auto">
            <div class="changePassword">
              <router-link to="/changePassword">
                <span>{{$t('Settings.title_1')}}</span>
                <i class="fa-solid fa-lock mx-2"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'setting',
  data(){
    return {
      userLang: 'ar',
    }
  },
  created(){
    this.userLang = localStorage.getItem('lang') ??  'ar';
  }
}
</script>
<style scoped>
  .container {
    height: 60vh;
  }
</style>